import { ExportField } from "@/configs/jtTypes";
import XLSX from "xlsx";
import get from "lodash.get";

export function exportExcel(datas: any[], columns: ExportField[]) {
  const exportData: any[] = [];
  if (datas) {
    datas.forEach(function (item, index) {
      const row: any = {};
      for (const clm of columns) {
        row[clm.header] = get(item, clm.fieldName);
      }
      exportData.push(row);
    });
    // console.log('exportData: ', exportData)
    // Export
    const workSet = XLSX.utils.json_to_sheet(exportData);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSet, "Sheet1");
    // writeFile - writeFileAsync
    XLSX.writeFile(workBook, "S-vip_export.xls");
  }
}
